import { render, staticRenderFns } from "./SCardUserComp.vue?vue&type=template&id=e7eddc72&"
import script from "./SCardUserComp.vue?vue&type=script&lang=js&"
export * from "./SCardUserComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports